<template>

  <div class="row">
    <div class="col-md-7 position-relative">
     
     <a :href="'https://www2.royaljardim.com.br/site/imovel/'+sugestao.IM_ID" target="_blank"> <img :src="'https://www2.royaljardim.com.br/sistema/fotos/'+sugestao.FOTO" class="img-fluid fix-images" /></a>
 </div>

       <div class="col-md-5 position-relative">
       <h5 style="">{{sugestao.ED_NOME}}</h5>
      <h6 style="color:#F6B400;">{{sugestao.IM_TIPO}}</h6>
      
      <p>Bairro: {{sugestao.BAI_NOME}}<br>
         Valor: {{sugestao.IM_VALOR}} <br>
         Referência: {{sugestao.IM_ID}}<br>
    
        <small><strong> {{sugestao.IM_ENDERECO}}<br>
          {{sugestao.IM_COMPLEMENTO}} - {{sugestao.CID_NOME}} - SP {{sugestao.IM_CEP}}</strong></small><br>
         
      </p>
      <div class="d-flex">
         <img src="/img/icon_res_area.png" style="width:30px;height:30px;" class="img-fluid colorless" /><p> {{sugestao.IM_AREAUTIL}}M<sup>2</sup></p>
          <img src="/img/icon_res_quarto.png" style="width:30px;height:30px;" class="img-fluid colorless ml-4" /><p> {{sugestao.IM_DORMITORIOS}} </p>
          <img src="/img/icon_res_vagas.png" style="width:40px;height:30px;" class="img-fluid colorless ml-4" /><p> {{sugestao.IM_NUMERO_GARAGENS}} </p>
      </div>
    </div><!-- col 3 -->
    <div class="w-100"></div>
     <div class="col-sm-2" v-if="loading" >
          <div class="spinner-border" role="status" style="max-height:40px;margin-top:35px;">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'ExibicaoImovel',
  props: {
    lead: String
  },
  data(){
     return {
        sugestao:null,
        loading: false
     }
  },

  methods:{
     getSugestoes(){
          this.loading = true;
          axios
         .post('https://www2.royaljardim.com.br/sistema/locacao/getImovel/'+this.lead)
         .then(response => {this.sugestao = response.data; console.log(response.data);})
         .catch(response => console.log(response))
         .finally(() =>  this.loading = false)
    }
  },

   mounted () {
   
     this.getSugestoes();
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.colorless{filter: grayscale(1);}
.fix-images{object-fit: cover;}
</style>
